import React from "react";
import { formatDateTime } from "../../../utils/newyear/eventDateUtils";
import useCountdown from "../../../hooks/newyear/useCountdown";

const DeadlineDisplay = ({ deadline, label = "마감일", onExpire }) => {
  const { isExpired, display } = useCountdown(deadline, { onExpire });

  if (!deadline) return null;

  return (
    <div className="newyear-deadline">
      <div className="newyear-deadline__info">
        <span className="newyear-deadline__label">{label}</span>
        <span className="newyear-deadline__date">{formatDateTime(deadline)}</span>
      </div>
      <div className="newyear-deadline__countdown">
        {isExpired ? (
          <span className="newyear-deadline__expired">마감됨</span>
        ) : (
          <span className="newyear-deadline__remaining">{display} 남음</span>
        )}
      </div>
    </div>
  );
};

export default DeadlineDisplay;
